var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"items-wrap orignal-cont"},[_c('div',{staticClass:"item"},[_c('div',{staticClass:"i-title"},[_vm._v("原始需求")]),_c('pre',{staticClass:"cont",domProps:{"innerHTML":_vm._s(_vm.ticket.client_raw_requirement)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }